import { render } from "./trainingManagement.svg?vue&type=template&id=382631c7"
const script = {}
script.render = render

export default script